<template>
  <div>
    <b-row style="width:100%;margin-right:0px !important; width:100%; color: aqua;" class="mx-0 w-100">
      <div class="career-header" style="width:100%">

        <b-row class="auth-inner m-0" style="width:100%">
          <!-- Brand logo-->
          <b-col cols="6" style="width:50%">
            <b-link class="brand-logo row ml-2 mt-2" style="color:dark-blue;" href="/careers">
              <vuexy-logo />
              <h2 class="brand-text  ml-1 title-heading-color title-logo">
                Moi Teaching And Referral Hospital
              </h2>
            </b-link>
          </b-col>

          <!-- /Brand logo-->

          <!-- Left Text-->
          <b-col class="pull-right" style="width:50%" cols="6">
            <div class="pull-right" style="float:right" @click=" navigateToPath()">
              <user-account id="tooltip-button-show-event" class="mx-3 mt-2" />
              <b-tooltip ref="tooltip" target="tooltip-button-show-event">
                <span v-if="isLoggedIn"> Open <strong> profile </strong></span>
                <span v-else> Click to <strong> Login </strong></span>
              </b-tooltip>
            </div>
          </b-col>
          <!-- /Left Text-->
        </b-row>
      </div>
    </b-row>
    <div style="margin:30px;">
      <h2 style="display:flex;justify-content:center">ADVERTISEMENT</h2>
    <b-row>
      <b-col></b-col>
      <p style="display:flex;justify-content:center">Moi Teaching and Referral Hospital (MTRH) is a Multi-Specialty National/International Teaching & Referral
        Hospital in the Western part of Kenya with a nucleus of 25 Counties, Eastern Uganda, Southern Sudan, Northern Tanzania and Democratic Republic of Congo amongst other areas.
        MTRH is committed in providing excellent Healthcare, with its;</p><b-col></b-col>
    </b-row>
      <b-col></b-col>
      <h2 style="display:flex;justify-content:center">Purpose</h2><b-col></b-col>
      <p style="display:flex;justify-content:center">To be Pro-Health and promote the well-being of the people and the planet where they live.</p><b-col></b-col>
      <b-col></b-col>
      <h2 style="display:flex;justify-content:center">True North</h2><b-col></b-col>
      <b-col></b-col>
      <p style="display:flex;justify-content:center">Excellent Healthcare Delivery</p><b-col></b-col>
      <b-col></b-col>
      <h2 style="display:flex;justify-content:center">&</h2><b-col></b-col>
      <b-col></b-col>
      <h2 style="display:flex;justify-content:center">Vision Statement</h2><b-col></b-col>
      <b-col></b-col>
      <p style="display:flex;justify-content:center">To be a Global Leader in the Provision of Exceptional Multi-Specialty Healthcare, Training and Research.</p><b-col></b-col>
    </div>
  <!-- <b-container  style="width: 100%;"  class="mx-2">
    <b-row class="mx-4-md mx-4-lg  mx-4-sm mt-2" style="width: 100%;">
      <b-col></b-col>
      <h2 style="display:flex;justify-content:center">ADVERTISEMENT</h2>
      <b-col></b-col>

    </b-row>

    <b-row class="mx-4-md mx-4-lg  mx-4-sm" style="width: 100%;">
      <b-col></b-col>
      <p>Moi Teaching and Referral Hospital (MTRH) is a Multi-Specialty National/International Teaching & Referral
        Hospital in the Western part of Kenya with a nucleus of 25 Counties, Eastern Uganda, Southern Sudan, Northern Tanzania and Democratic Republic of Congo amongst other areas.
        MTRH is committed in providing excellent Healthcare, with its;</p><b-col></b-col>
    </b-row>

    <b-row class="mx-4-md mx-4-lg  mx-4-sm mt-2" style="width: 100%;">
      <b-col></b-col>
      <h2>Purpose</h2><b-col></b-col>
    </b-row>

    <b-row class="mx-4-md mx-4-lg  mx-4-sm" style="width: 100%;">
      <b-col></b-col>
      <p>To be Pro-Health and promote the well-being of the people and the planet where they live.</p><b-col></b-col>
    </b-row>

    <b-row class="mx-4-md mx-4-lg  mx-4-sm mt-2" style="width: 100%;">
      <b-col></b-col>
      <h2>True North</h2><b-col></b-col>
    </b-row>

    <b-row class="mx-4-md mx-4-lg  mx-4-sm" style="width: 100%;">
      <b-col></b-col>
      <p>Excellent Healthcare Delivery</p><b-col></b-col>
    </b-row>
    <b-row class="mx-4-md mx-4-lg  mx-4-sm mt-2" style="width: 100%;">
      <b-col></b-col>
      <h2>&</h2><b-col></b-col>
    </b-row>
    <b-row class="mx-4-md mx-4-lg  mx-4-sm mt-2" style="width: 100%;">
      <b-col></b-col>
      <h2>Vision Statement</h2><b-col></b-col>
    </b-row>
    <b-row class="mx-4-md mx-4-lg  mx-4-sm" style="width: 100%;">
      <b-col></b-col>
      <p>To be a Global Leader in the Provision of Exceptional Multi-Specialty Healthcare, Training and Research.</p><b-col></b-col>
    </b-row>
  </b-container> -->

    <b-row> <job-list class="mx-4-md mx-4-lg  mx-4-sm" /></b-row>
    <b-container />
  </div>
</template>
<script>
import {
  BContainer, BRow, BLink, BTooltip,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { isUserLoggedIn } from '@/auth/utils'
import UserAccount from './UserAccount.vue'
import JobList from './JobList.vue'

export default {
  components: {
    BContainer,
    BRow,
    JobList,
    BLink,
    VuexyLogo,
    UserAccount,
    BTooltip,
  },
  data() {
    return { isLoggedIn: null }
  },
  created() {
    this.isLoggedIn = isUserLoggedIn()
  },
  methods: {
    goToLogin() {
      this.$router.push({ name: 'auth-login' })
    },
    openDashboard() {
      this.$router.push({ name: 'careersprofile' })
      //this.$router.push({ name: 'careers-account-setting' })
    },
    navigateToPath() {
      //this.$router.push({ name: 'auth-forgot-password' })
      
      if (this.isLoggedIn) {
        
        this.openDashboard()
        console.log('hey im here---')
        console.log('??????????',this.isLoggedIn)
      } else {
        this.goToLogin()
      }
    },
  },

}
// banner_mtrh.jpeg
</script>
<style lang="scss" scoped>
@import '@core/scss/vue/pages/page-auth.scss';

.career-header {
  background: url('~@/assets/images/logo/mtrh_page.jpg'); 
  background-color: #cccccc;
  height: 600px;
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  width: 100% !important;
  margin-right: 0px !important;
}

.title-heading-color {
  color: #0a367b;
  background: rgba(255, 255, 255, 0.5);
  height: 29px;
  padding-right: 10px;
  padding-left: 10px;
  font-weight: 900;
}

@media only screen and (max-width: 600px) {
  .title-logo {
    font-size: 12px;
  }
}
</style>
